<div 
  id='overlay-container'
  *ngIf="overlayVisivel"
  class="ui-widget-overlay overlay-container overlay-container-inativo" 
  >
  <!-- style="z-index: 9001010;" -->
</div>
